import { useStore } from '@/containers'

interface OriginPriceType {
  type?: string
  classes?: string
  originPrice: number
}

export const OriginPrice = ({ originPrice, classes }: OriginPriceType) => {
  const { selectedLang } = useStore()
  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'USD'
      default:
        return 'VND'
    }
  }
  return (
    <div className={`cursor-pointer text-xs leading-none text-black-100 line-through ${classes ? classes : ''}`}>
      {originPrice &&
        originPrice
          .toLocaleString(selectedLang as string, {
            style: 'currency',
            currency: currency(selectedLang as string)
          })
          .replace(/\s₫/g, 'đ')}
    </div>
  )
}

export default OriginPrice
